"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AstraCaBAdminAPI = void 0;
const net = require("@ivanlog/net");
const ActiveManager_1 = require("./classes/ActiveManager");
const Auth_1 = require("./classes/Auth");
const Coupons_1 = require("./classes/Coupons");
const Directory_1 = require("./classes/Directory");
const Files_1 = require("./classes/Files");
const HotMessages_1 = require("./classes/HotMessages");
const Maintenance_1 = require("./classes/Maintenance");
const Notifications_1 = require("./classes/Notifications");
const Profile_1 = require("./classes/Profile");
const Profiles_1 = require("./classes/Profiles");
class AstraCaBAdminAPI {
    /**
    * @param {string} url baseUrl for api
    * @param {(e: unknown, args?: unknown) => void} errorsHandler? errors handler for safe methods
    */
    constructor(url, errorsHandler) {
        this._httpClient = new net.HTTPClient(url);
        this.activeManager = new ActiveManager_1.ActiveManager(this._httpClient, errorsHandler);
        this.auth = new Auth_1.Auth(this._httpClient, errorsHandler);
        this.coupons = new Coupons_1.Coupons(this._httpClient, errorsHandler);
        this.directory = new Directory_1.Directory(this._httpClient, errorsHandler);
        this.files = new Files_1.Files(this._httpClient, errorsHandler);
        this.hotMessages = new HotMessages_1.HotMessages(this._httpClient, errorsHandler);
        this.maintenance = new Maintenance_1.Maintenance(this._httpClient, errorsHandler);
        this.notifications = new Notifications_1.Notifications(this._httpClient, errorsHandler);
        this.profile = new Profile_1.Profile(this._httpClient, errorsHandler);
        this.profiles = new Profiles_1.Profiles(this._httpClient, errorsHandler);
    }
    getHTTPClient() {
        return this._httpClient;
    }
}
exports.AstraCaBAdminAPI = AstraCaBAdminAPI;
//# sourceMappingURL=AstraCabAdminAPI.js.map